import React from 'react';
import classnames from 'classnames';
import Footer from '../Footer';
import { PageNavigation } from '@ignitesales/neuro-application';

const SurveyPageSkeleton = () => {
  const classes = classnames('surveyPage', 'surveyPage--skeleton');

  return (
    <div className={classes}>
      <div className="questionGroups clear">
        <section className="questionGroup questionGroup--centered">
          <div className="question">
            <h3 className="question__text">
              <span />
              <div className="subtext">
                <span />
              </div>
              <div className="subtext">
                <span />
              </div>
            </h3>
            <div className="question__skeleton" />
          </div>
        </section>
      </div>
    </div>
  );
};

export default SurveyPageSkeleton;
